import { gql } from '@nerdwallet/apollo';

const marketplaceEntityWithPlacementDrivers = gql`
  fragment PlacementDrivers on MarketplaceEntityWithPlacementInterface {
    placementDrivers {
      id
      value
      description
      label
      valueTooltip
      valueTooltipHasHtml
    }
  }
`;

const imageFields = gql`
  fragment ImageFields on EntityPlacementImage {
    alt
    height
    source
    width
    resizableImagePath
    sourceLarge
    sourceMedium
  }
`;

const ctaFields = gql`
  fragment CtaFields on EntityPlacementCTA {
    link
    showIcon
    subtext
    text
    type
  }
`;

const creditCardsOfferQuery = gql`
  fragment CreditCardsOffer on CreditCardsOfferV2 {
    id
    name
    status
    displayName
    entityType
    productType
    marketingBullets
    minFico
    maxFico
    limitedCreditHistory
    termsAndFeesLink
    rewardsRates {
      description
    }
    starRating
    starRatingTooltip
    reviewLink
    ratesAndFeesCta {
      link
      text
      showIcon
      type
      subtext
    }
    recommendedCreditScoreRangeDetails {
      creditScoreRange
      description
    }
    cta {
      ...CtaFields
    }
    image {
      ...ImageFields
    }
    bestOfAwards {
      category
      year
    }
    structuredContentCons
    structuredContentPros
    slug
    monetizable
    recommendedCreditScoreRangeDetails {
      creditScoreRange
      description
    }

    # for rewards DRIVER_GROUP feature
    driverAnnualFee {
      id
      description
      label
      value
    }

    driverIntroApr {
      id
      description
      label
      value
    }

    driverRegularApr {
      id
      description
      label
      value
    }
  }
`;

const bankingOfferQuery = gql`
  fragment BankingOffer on BankingOfferV2 {
    id
    displayName
    apy
    starRating
    federallyInsuredAnnotation
    entityType
    cta {
      ...CtaFields
    }
    image {
      ...ImageFields
    }
    structuredContentCons
    structuredContentPros
  }
`;

const investingOfferQuery = gql`
  fragment InvestingOffer on InvestingOfferV2 {
    id
    starRating
    displayName
    reviewedAtDate
    periodConsideredDate
    monetizable
    entityType
    cta {
      ...CtaFields
    }
    image {
      ...ImageFields
    }
    structuredContentCons
    structuredContentPros
  }
`;

const studentLoansOfferQuery = gql`
  fragment EducationLoansOffer on EducationLoansOfferV2 {
    id
    starRating
    displayName
    disclaimer
    availableTermLengths
    cta {
      ...CtaFields
    }
    image {
      ...ImageFields
    }
    structuredContentCons
    structuredContentPros
  }
`;

const personalLoansOfferQuery = gql`
  fragment PersonalLoansOffer on PersonalLoansOfferV2 {
    id
    starRating
    displayName
    disclaimer
    availableTermLengths
    qualificationsBullets
    feesBullets
    cta {
      ...CtaFields
    }
    image {
      ...ImageFields
    }
    structuredContentCons
    structuredContentPros
  }
`;

const mortgagesLoansOfferQuery = gql`
  fragment MortgagesOffer on MortgagesOfferV2 {
    id
    starRating
    displayName
    cta {
      ...CtaFields
    }
    image {
      ...ImageFields
    }
    structuredContentCons
    structuredContentPros
  }
`;

const insuranceLoansOfferQuery = gql`
  fragment InsuranceOffer on InsuranceOfferV2 {
    id
    starRating
    displayName
    reviewLink
    cta {
      ...CtaFields
    }
    image {
      ...ImageFields
    }
    structuredContentCons
    structuredContentPros
  }
`;

export const marketplaceOffers = gql`
  query MarketplaceEntitiesV2($ids: [ID!]) {
    marketplaceEntitiesV2(ids: $ids) {
      id
      name
      entityType
      productType
      status
      __typename
      ...CreditCardsOffer
      ...BankingOffer
      ...InvestingOffer
      ...EducationLoansOffer
      ...PersonalLoansOffer
      ...MortgagesOffer
      ...InsuranceOffer

      ...PlacementDrivers
    }
  }
  ${ctaFields}
  ${imageFields}
  ${marketplaceEntityWithPlacementDrivers}
  ${creditCardsOfferQuery}
  ${bankingOfferQuery}
  ${investingOfferQuery}
  ${studentLoansOfferQuery}
  ${personalLoansOfferQuery}
  ${mortgagesLoansOfferQuery}
  ${insuranceLoansOfferQuery}
`;
